<template>
  <div>

  <v-layout row justify-space-between>
    <v-flex>
      <v-card>
        <v-card-title>
          <h2 class="all-caps subheading">
            On Team
          </h2>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="teamSearch"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :items='teamMembers'
          :search='teamSearch'
          :headers='teamHeaders'
          :pagination.sync="teamMembersSort"
          select-all
          item-key="id"
        >
          <template slot="headers" slot-scope="{ header }">
            <tr>
              <th>
                <v-checkbox
                  hide-details
                  @click.stop="toggleAllTeamMembers"
                ></v-checkbox>
              </th>
              <th
                v-for="header in teamHeaders"
                :key="header.text"
                >{{ header.text }}</th>
            </tr>
          </template>
          <template slot="items" slot-scope="{ item }">
            <tr @click="toggleEmployeePullOffSelected(item)">
              <td>
                <v-checkbox
                  :input-value="employeeIsPullOffSelected(item)"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                <EmployeeName :employee="item" showColor />
              </td>
              <td>{{ item.positions }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <v-flex>
      <v-layout justify-center fill-height column>
        <v-btn
          @click="addSelected"
          :loading="teamAdjustApiPending"
          :disabled="teamAdjustApiPending"
        >
          <v-icon left>
            arrow_left
          </v-icon>
            Add Selected
        </v-btn>
        <v-btn
          @click="removeSelected"
          :loading="teamAdjustApiPending"
          :disabled="teamAdjustApiPending"
        >
            Remove Selected
          <v-icon right>
            arrow_right
          </v-icon>
        </v-btn>
      </v-layout>
    </v-flex>

    <v-flex>
      <v-card>
        <v-card-title>
          <h2 class="all-caps subheading">
            Available Employees
          </h2>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="employeesSearch"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :items='availableAndEligible'
          :search='employeesSearch'
          :headers='teamHeaders'
          :pagination.sync="employeesSort"
          select-all
          item-key="id"
        >
          <template slot="headers" slot-scope="{ header }">
            <tr>
              <th>
                <v-checkbox
                  hide-details
                  @click.stop="toggleAllEmployees"
                ></v-checkbox>
              </th>
              <th
                v-for="header in teamHeaders"
                :key="header.text"
                >{{ header.text }}</th>
            </tr>
          </template>
          <template slot="items" slot-scope="{ item }">
            <tr @click="toggleEmployeeSelected(item)">
              <td>
                <v-checkbox
                  :input-value="employeeIsSelected(item)"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                <EmployeeName :employee="item" showColor />
                <router-link
                  :to="{ name: 'employeeDetail', params: { employeeId: item.id } }"
                  target="_blank"
                >
                <v-icon small>open_in_new</v-icon>
                </router-link>
              </td>
              <td>{{ item.positions }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout column class="mb-4 mt-4">
    <v-flex>
      <v-dialog persistent v-model="addEmployeesIneligibleDialog" max-width="600">
        <v-btn slot='activator' class="ml-0">
          Add Ineligible Employees
        </v-btn>
        <v-card>
          <v-card-title class="headline">
            <v-layout align-center justify-space-between>
              <v-flex>
                Add Ineligible Employees
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn icon @click="addEmployeesIneligibleDialog = false">
                  <v-icon>
                    close
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              label="Choose Ineligible Employees"
              v-model="ineligibleEmployeesSelected"
              :items="allEmployeesExceptIneligible"
              chips
              multiple
              item-text="name"
              return-object
              clearable
            >
            <template slot="item" slot-scope="data">
              <LocationName :location="data.item" showColor noLink />
            </template>
            </v-autocomplete>
          </v-card-text>
            <v-spacer></v-spacer>
            <v-layout row>
              <v-flex>
                <v-btn color="grey" flat @click="addEmployeesIneligibleDialog = false">Nevermind</v-btn>
              </v-flex>
              <v-flex>
                <v-layout column>
                  <v-btn color='success' small :loading="apiCallPending" @click="addSelectedIneligibleEmployees">
                    Add Selected Employees
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
        </v-card>
      </v-dialog>
      <v-btn @click="removeSelectedIneligibleEmployees" :disable="ineligibleEmployeesSelectedToRemove.length < 0">
        Remove Ineligible Employees
      </v-btn>
    </v-flex>
    <v-flex>
      <template>
      <v-card class="pa-2">
        <v-card-title>
          <h2 class="all-caps subheading">
            Ineligible Employees
          </h2>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="ineligibleEmployeeSearch"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            class="ml-2"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :items='ineligibleTeamMembers'
          :search='ineligibleEmployeeSearch'
          :headers='ineligibleEmployeesHeaders'
          :pagination.sync="defaultSort"
          select-all
          item-key="name"
        >
          <template slot="headers" slot-scope="{ header }">
            <tr>
              <th>
                <v-checkbox
                  hide-details
                  @click.stop="ineligibleToggleAll"
                ></v-checkbox>
              </th>
              <th
                v-for="header in ineligibleEmployeesHeaders"
                :key="header.text"
                ><v-layout justify-left>{{ header.text }}</v-layout></th>
            </tr>
          </template> 
          <template slot="items" slot-scope="{ item }">
            <tr @click="toggleEmployeeRemoveIneligibleSelected(item)">
              <td>
                <v-checkbox
                  :input-value="employeeIsRemoveIneligibleSelected(item)"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                <LocationName :location="item" showColor noLink />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      </template>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import collectionsApi from '@/api/collections'
import ApiField from '@/components/base/api-field.vue'

export default {
  props: [
    'location',
    'allEmployees',
  ],
  components: {
    ApiField,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    availableEmployees: function () {
      return this.allEmployees.filter(e => {
        if (this.teamMembers.map(tm => tm.id).includes(e.id)) {
        } else {
          return e
        }
      })
    },
    availableAndEligible: function() {
      return this.availableEmployees.filter(e => {
        if (this.ineligibleTeamMembers.map(tm => tm.id).includes(e.id)) {
        } else {
          return e
        }
      })
    },
    allEmployeesExceptIneligible: function() {
      return this.allEmployees
      .filter(e => {
        if (this.ineligibleTeamMembers.map(tm => tm.id).includes(e.id)) {
        } else {
          return e
        }
      });
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      teamAdjustApiPending: false,
      apiCallPending: false,
      teamSearch: '',
      employeesSearch: '',
      employeesSort: {
        sortBy: 'name',
        ascending: true,
        rowsPerPage: 10,
      },
      teamMembersSort: {
        sortBy: 'name',
        ascending: true,
        rowsPerPage: 10,
      },
      teamMembers: [],
      teamHeaders: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
          align: 'left',
        },
        {
          text: 'Positions',
          value: 'positions',
          sortable: true,
          align: 'left',
        }
      ],
      teamSelectionLoading: false,
      teamSelectionErrors: [],
      teamSelectionSuccesses: [],
      apiCallPending: false,
      employeesSelected: [],
      employeesPullOffSelected: [],
      defaultSort: {
        sortBy: 'name',
        ascending: true,
        rowsPerPage: 10,
      },
      addEmployeesIneligibleDialog: false,
      ineligibleTeamMembers: [],
      ineligibleEmployeesSelected: [],
      ineligibleEmployeesSelectedToRemove: [],
      ineligibleEmployeesHeaders: [
        {
          text: 'Name',
          value: 'name',
          sortable: 'true',
          align: 'left',
        }
      ],
      ineligibleEmployeeSearch: '',
    }
  },
  methods: {
    toggleAllEmployees: function () {
      if (this.employeesSelected.length > 0) {
        this.employeesSelected = []
      } else {
        this.employeesSelected = this.allEmployees
      }
    },
    toggleAllTeamMembers: function () {
      if (this.employeesPullOffSelected.length > 0) {
        this.employeesPullOffSelected = []
      } else {
        this.employeesPullOffSelected = this.teamMembers.slice()
      }
    },
    toggleEmployeeSelected: function(emp) {
      if (this.employeesSelected.indexOf(emp) > -1) {
        this.employeesSelected = this.employeesSelected.filter(e => e !== emp)
      } else {
        this.employeesSelected.push(emp)
      }
    },
    toggleEmployeePullOffSelected: function(employee) {
      if (this.employeesPullOffSelected.indexOf(employee) > -1) {
        this.employeesPullOffSelected = this.employeesPullOffSelected.filter(e => t !== employee)
      } else {
        this.employeesPullOffSelected.push(employee)
      }
    },
    employeeIsSelected: function(emp) {
      if (this.employeesSelected.indexOf(emp) > -1) {
        return true
      }
    },
    employeeIsPullOffSelected: function(employee) {
      if (this.employeesPullOffSelected.indexOf(employee) > -1) {
        return true
      }
    },

    addSelected () {
      this.teamAdjustApiPending = true
      let employeeIds = this.teamMembers
        .map(e => e.id)
        .concat(this.employeesSelected.map(e => e.id))

      this.$store.dispatch('teams/updateTeamsAt', {
        locationId: this.location.id,
        employeeIds: employeeIds
      })
      .then(res => {
        this.teamMembers = res
      })
      .catch(e => {
        console.log(e)
      })
      .finally(r => {
        this.teamAdjustApiPending = false
      })
    },

    removeSelected () {
      this.teamAdjustApiPending = true
      let employeeIds = this.teamMembers
        .map(e => e.id)
        .filter(e => !this.employeesPullOffSelected.map(e => e.id).includes(e))

      this.$store.dispatch('teams/updateTeamsAt', {
        locationId: this.location.id,
        employeeIds: employeeIds
      })
      .then(res => {
        this.teamMembers = res
      })
      .catch(e => {
        console.log(e)
      })
      .finally(r => {
        this.teamAdjustApiPending = false
      })
    },
    ineligibleToggleAll: function () {
      if (this.ineligibleEmployeesSelectedToRemove.length > 0) {
        this.ineligibleEmployeesSelectedToRemove = []
      } else {
        this.ineligibleEmployeesSelectedToRemove = this.ineligibleTeamMembers.slice()
      }
    },
    toggleEmployeeRemoveIneligibleSelected: function(employee) {
      if (this.ineligibleEmployeesSelectedToRemove.indexOf(employee) > -1) {
        this.ineligibleEmployeesSelectedToRemove = this.ineligibleEmployeesSelectedToRemove.filter(t => t !== employee)
      } else {
        this.ineligibleEmployeesSelectedToRemove.push(employee)
      }
    },
    employeeIsRemoveIneligibleSelected: function(employee) {
      if (this.ineligibleEmployeesSelectedToRemove.indexOf(employee) > -1) {
        return true
      }
    },
    addSelectedIneligibleEmployees: function() {
      this.teamSelectionLoading = true;
      let employeeIds = this.teamMembers
        .map(e => e.id)
        .filter(e => !this.ineligibleEmployeesSelected.map(e => e.id).includes(e))

      this.$store.dispatch(
        'teams/addIneligibleTeamMembers', { 
        locationId: this.location.id, 
        ineligible_employees: this.ineligibleEmployeesSelected.map(t => t.id) 
        }
      )
      .then(res => {
        //console.log('this is the result ' + res)
        this.ineligibleTeamMembers = res
      })
      .catch(e => {
        console.log(e)
      })
      .finally(res => {
        this.addEmployeesIneligibleDialog = false;
      }),

      this.$store.dispatch(
        'teams/updateIneligibleTeamsAt', { 
        locationId: this.location.id, 
        ineligible_employees: this.ineligibleEmployeesSelected.map(t => t.id) 
        }
      )
      .then(res => {
        // this.ineligibleTeamMembers = res 
      })
      .catch(e => {
        console.log(e)
      })
      .finally(res => {

      }),

      this.$store.dispatch('teams/updateTeamsAt', { 
        locationId: this.location.id, 
        employeeIds: employeeIds 
        }
      )
      .then(res => {
        this.teamMembers = res
        this.teamSelectionErrors = []
        this.teamSelectionSuccesses.push("Saved!")
        this.successClear = setInterval(() => {
          this.teamSelectionErrors = []
        }, 1500);

      })
      .catch(res => {
        this.teamSelectionErrors.push("Couldn't be saved")
        console.log(e)
      })
      .finally(res => {
        this.teamSelectionLoading = false
        this.ineligibleTeamsSelected = []
        this.teamAdjustApiPending = false
      })
      
      this.apiCallPending = false
      this.addEmployeesIneligibleDialog = false
      this.ineligibleEmployeesSelected = false
    },
    
    removeSelectedIneligibleEmployees: function() {
      if (this.ineligibleEmployeesSelectedToRemove.length == 0) {
        return
      }

      this.$store.dispatch('teams/removeIneligibleTeamMembers', {
        locationId: this.location.id,
        ineligible_employees: this.ineligibleEmployeesSelectedToRemove.map(t => t.id)
      })
      .then(res => {
        //console.log('this is the res from removeIneligibleTeamMembers: ')
        //console.log(res)
        this.ineligibleTeamMembers = res
      })
      .catch(e => {
      })
      .finally(r => {
        this.ineligibleEmployeesSelectedToRemove = []
      })
    },

    setUp () {
      // get own team by location
      this.apiCallPending = true
      this.$store.dispatch('teams/getAtLocation', this.location.id)
        .then(teamMembers => {
          this.teamMembers = teamMembers
        })
        .catch(e => {
          console.log(e)
        })
        .finally(r => {
          this.apiCallPending = false
        }),
      this.$store.dispatch('teams/getIneligibleAtLocation', this.location.id)
        .then(ineligibleTeamMembers => {
          this.ineligibleTeamMembers = ineligibleTeamMembers
        })
        .catch(e => {
          console.log(e)
        })
        .finally(r => {
          this.apiCallPending = false
        })
    },
  }
}
</script>

<style scoped>
</style>
